// Mirror BE TechnikaMappingService.extractVolaciZnak — formát textu z KOPIS emailu:
// "DA Renault Master - HOP 626" → volací znak za posledním " - " ("HOP 626").
// Pokud text neobsahuje " - ", vrátí celý trim text (defenzivní fallback pro nečekané formáty).
export const extractVolaciZnak = (text: string): string => {
    const trimmed = text.trim();
    const lastDash = trimmed.lastIndexOf(' - ');
    if (lastDash >= 0 && lastDash + 3 < trimmed.length) {
        return trimmed.substring(lastDash + 3).trim();
    }
    return trimmed;
};

// Rozparsuje text emailu na volací znak (po posledním " - ") a název (před).
// Reálný formát: "CAS 32/8200/800-S3R T815 - HPE 542" (žádný prefix jednotky).
// Defenzivně: pokud by text obsahoval prefix "<jednotka>: ", prefix se odstřihne
// (např. POSILY z dalších jednotek mohou být formátované s prefixem).
// Pokud text neobsahuje " - ", celý zbytek (po případném strip prefixu) je volací znak.
export const splitEmailText = (text: string): { volaciZnak: string; nazev: string } => {
    const trimmed = text.trim();
    const colon = trimmed.indexOf(': ');
    const body = colon >= 0 ? trimmed.substring(colon + 2).trim() : trimmed;
    const lastDash = body.lastIndexOf(' - ');
    if (lastDash >= 0 && lastDash + 3 < body.length) {
        return {
            volaciZnak: body.substring(lastDash + 3).trim(),
            nazev: body.substring(0, lastDash).trim(),
        };
    }
    return { volaciZnak: body, nazev: '' };
};
